import { __name } from './chunk-Q72B4Q5Z.mjs';
import fs from 'node:fs';

function isDirectory(path) {
  return fs.statSync(path, { throwIfNoEntry: false })?.isDirectory() ?? false;
}
__name(isDirectory, "isDirectory");
function removeDir(dirPath, { fireAndForget = false } = {}) {
  const result = fs.promises.rm(dirPath, {
    recursive: true,
    force: true,
    maxRetries: 5,
    retryDelay: 100
  });
  if (fireAndForget) {
    void result.catch(() => {
    });
  } else {
    return result;
  }
}
__name(removeDir, "removeDir");
function removeDirSync(dirPath) {
  fs.rmSync(dirPath, {
    recursive: true,
    force: true,
    maxRetries: 5,
    retryDelay: 100
  });
}
__name(removeDirSync, "removeDirSync");

export { isDirectory, removeDir, removeDirSync };
